export const FILTER_SET_BEGIN = 'syftacp/FILTER_SET_BEGIN'
export const FILTER_RESET_BEGIN = 'syftacp/FILTER_RESET_BEGIN'
export const PAGE_SET_BEGIN = 'syftacp/PAGE_SET_BEGIN'
